import React from "react";
import { Link } from "react-router-dom";

export default function PaymentCancel() {
  return (
    <div className="container-lookers py-24 text-center max-w-lg mx-auto" data-testid="payment-cancel-page">
      <h1 className="font-serif text-4xl mb-4 text-zinc-900">
        Payment Cancelled
      </h1>
      <p className="text-sm text-zinc-500 mb-8">Your order was not completed. Your bag is still saved if you'd like to try again.</p>
      <Link to="/cart" className="bg-teal-600 hover:bg-teal-700 text-ink px-6 py-3 text-xs font-heading font-semibold uppercase tracking-wide rounded-full transition-colors">Return To Bag</Link>
    </div>
  );
}
